import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { News, Organisation } from '../../../models/types';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-add-news',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './add-news.component.html',
  styleUrls: ['./add-news.component.scss'],
})
export class AddNewsComponent {
  @Input() organisation: Organisation | null = null;
  @Input() isEditMode: boolean = false;
  @Input() existingNews: News | null = null;

  newNews: News = {
    newsID: 0,
    organisationID: -1,
    title: '',
    summary: '',
    body: '',
    imageRef: '',
    publishedAt: new Date(),
    facebookLink: '',
    author: '',
  };

  faImage = faImage;
  previewImageSrc: string | ArrayBuffer | null = null;
  imageFile: File | undefined;
  imageChanged: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private organisationService: OrganisationServiceService
  ) {}

  ngOnInit() {
    if (this.isEditMode && this.existingNews) {
      this.newNews = { ...this.existingNews };
      this.previewImageSrc = this.newNews.imageRef;
    } 
  }

  addNews() {
    if (!this.newNews.title || !this.newNews.summary || !this.newNews.body) {
      Swal.fire('Napaka', 'Vsi podatki so obvezni!', 'error');
      return;
    }
    if (!this.isEditMode && !this.imageFile) {
      Swal.fire('Napaka', 'Dodajanje slike je obvezno', 'error');
      return;
    }

    if (this.isEditMode ) {
      this.newNews.imageRef = this.newNews.imageRef?.split('/').pop() ?? '';
      this.organisationService.updateNews(this.newNews).subscribe({
        next: () => {
          Swal.fire('Uspeh', 'Novica je bila posodobljena', 'success');
          if (this.imageFile && this.imageChanged) {
            this.updateImageFile(this.newNews.newsID);
            this.imageChanged = false;
          } else {
            this.activeModal.close('newsAdded');
            this.closeModal();
          }
        },
        error: () => Swal.fire('Napaka', 'Posodobitev ni uspela', 'error'),
      });
    } else {
      this.newNews.organisationID = this.organisation?.organisationID ?? -1;
      this.organisationService.addNews(this.newNews).subscribe((response) => {
        if (response && response.news_id) {
          Swal.fire('Uspeh', 'Novica je bila dodana', 'success');
          const newsID = response.news_id;
          this.uploadImageFile(newsID);
        } else {
          Swal.fire('Napaka', 'Pri dodajanju novice je prišlo do napake', 'error');
        }
      });
    }
  }
  
  uploadImageFile(newsID: number) {
    if (this.imageFile) {
      this.organisationService.uploadNewsImage(newsID, this.imageFile).subscribe((response) => {
        if (response) {
          this.activeModal.close('newsAdded');
        } else {
          Swal.fire('Napaka', 'Napaka pri dodajanju slike', 'error');
        }
      });
    } else {
      Swal.fire('Napaka', 'Dodajanje slike je obvezno', 'error');
    }
  }

  updateImageFile(newsID: number) {
    if (this.imageFile) {
      this.organisationService.updateNewsImage(newsID, this.imageFile).subscribe((response) => {
        if (response) {
          this.activeModal.close('newsAdded');
        } else {
          Swal.fire('Napaka', 'Napaka pri dodajanju slike', 'error');
        }
      });
    } else {
      Swal.fire('Napaka', 'Dodajanje slike je obvezno', 'error');
    }
  }

  onImageUploadChanged(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.imageChanged = true;
      this.organisationService.compressImage(file, 70, 40).then((compressedFile) => {
        this.imageFile = compressedFile;
        this.previewImageSrc = URL.createObjectURL(compressedFile);
      }).catch(error => console.error('Error compressing image:', error));
    }
  }

  closeModal() {
    this.activeModal.dismiss('cancel');
  }
}
